// removed by extract-text-webpack-plugin
module.exports = {"ThreadTab":"src-components-Messages-styles-__tabs__ThreadTab--2tVch"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles/tabs.css
// module id = 1971
// module chunks = 0